import React from "react"
import { NavBarPortfolioSelector } from "./NavBarPortfolioSelector"
import { Business } from "@/schemas/business"; // Changed to Zod-inferred type
import { NavBarBusinessSelector } from "./NavBarBusinessSelector"

interface NavBarMobileRowsProps {
  businessName?: string
  allBusinesses: Business[]
  handleNavigation: (id: string) => void
  portfolioDropdown?: boolean
  selectedPortfolio?: string
  portfolioOptions?: Array<{
    id: string
    title?: string
    name?: string
    role?: string | null
  }>
  onPortfolioChange?: (value: string) => void
}

export const NavBarMobileRows: React.FC<NavBarMobileRowsProps> = ({
  businessName,
  allBusinesses,
  handleNavigation,
  portfolioDropdown = false,
  selectedPortfolio = "",
  portfolioOptions = [],
  onPortfolioChange,
}) => {
  return (
    <div className="flex flex-col w-full border-t border-gray-200">
      <div className="max-w-screen-xl mx-auto px-4 py-2 w-full">
        {/* Show either portfolio or business selector based on the current page */}
        {portfolioDropdown ? (
          <NavBarPortfolioSelector
            selectedPortfolio={selectedPortfolio}
            portfolioOptions={portfolioOptions.map((p) => ({
              id: p.id,
              title: p.title || p.name || "Unnamed Portfolio",
              role: p.role || null,
            }))}
            onPortfolioChange={onPortfolioChange || (() => {})}
            isMobile={true}
          />
        ) : (
          <NavBarBusinessSelector
            businessName={businessName}
            allBusinesses={allBusinesses}
            onBusinessSelect={handleNavigation}
            isMobile={true}
          />
        )}
      </div>
    </div>
  )
}
